export default __webpack_public_path__ + "static/media/ImprovingPhysical_main.06b65c51.png";